/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type EligibilityCriteriaDtoOperand =
  (typeof EligibilityCriteriaDtoOperand)[keyof typeof EligibilityCriteriaDtoOperand];

export const EligibilityCriteriaDtoOperand = {
  AT_LEAST: 'AT_LEAST',
  AT_MOST: 'AT_MOST',
  BETWEEN: 'BETWEEN',
  EQUAL: 'EQUAL',
  GREATER: 'GREATER',
  IN: 'IN',
  LESS: 'LESS',
  NOT_EQUAL: 'NOT_EQUAL',
} as const;
